import { createSelector } from 'reselect'

export const createFilterSelector = (filterName) => (
  createSelector(
    ({ filters }) => filters,
    ({ [filterName]: filter }) => filter || {}
  )
)

export const createPaginationSelector = (filterName) => (
  createSelector(
    createFilterSelector(filterName),
    ({ groups }) => (groups ? groups.pagination : false)
  )
)

const createCollectionSelector = (filterName) => (
  createSelector(
    createFilterSelector(filterName),
    ({ groups }) => (groups?.collection || [])
  )
)

export const createSelectedItemsSelector = (filterName) => (
  createSelector(
    createFilterSelector(filterName),
    ({ selected_items: selectedItems }) => (selectedItems || [])
  )
)

export const createSelectedIdsSelector = (filterName) => (
  createSelector(
    createFilterSelector(filterName),
    (({ selected_ids: selectedIds }) => (selectedIds))
  )
)

const createSelectedItemsIdsPerGroupSelector = (filterName) => (
  createSelector(
    createSelectedItemsSelector(filterName),
    (selectedItems) => {
      const ids = {}
      selectedItems.forEach((item) => {
        if (!ids[item.group.key]) {
          ids[item.group.key] = []
        }
        ids[item.group.key].push(item.id)
      })
      return ids
    }
  )
)

export const getAllFlatItemsSelector = (filterName) => (
  createSelector(
    createCollectionSelector(filterName),
    createSelectedItemsSelector(filterName),
    createSelectedIdsSelector(filterName),
    (groups, selectedCollection, groupIds) => {
      const ids = Object.values(groupIds).flat()

      return [
        ...groups.map(({ items: { collection } }) => collection).flat(),
        ...selectedCollection
      ].filter((({ id }) => ids.includes(id)))
    }
  )
)

export const createUnselectedGroupsSelector = (filterName) => (
  createSelector(
    createCollectionSelector(filterName),
    createSelectedItemsIdsPerGroupSelector(filterName),
    (collection, selectedIdsInGroup) => (
      collection.map((group) => {
        const { items, key } = group

        if (!selectedIdsInGroup[key]) {
          return group
        }

        const newItemCollection = items.collection.filter(
          (item) => !selectedIdsInGroup[key].includes(item.id)
        )

        return {
          ...group,
          items: {
            ...items,
            collection: newItemCollection
          }
        }
      })
    )
  )
)

const createGroupHasSelectedItemsSelector = (filterName, group) => (
  createSelector(
    createSelectedItemsSelector(filterName),
    (selectedItems) => (
      selectedItems.find((item) => item.group.key === group.key)
    )
  )
)

// i18n-tasks-use t('publisher.scheduled_events.filters.all_items_selected')
// i18n-tasks-use t('publisher.scheduled_events.filters.no_items_found')
export const createGroupPlaceholderSelector = (filterName, group) => (
  createSelector(
    createGroupHasSelectedItemsSelector(filterName, group),
    (hasSelectedItems) => (
      (group.items.collection.length === 0)
      && (hasSelectedItems ? 'all_items_selected' : 'no_items_found')
    )
  )
)
